import _ from "lodash";
import { usePruneInactiveStoryboards } from "@/hooks/storyboards/usePruneInactiveStoryboards";
import { useTailwindClasses } from "@/hooks/useTailwindClasses";

export const CanvasSideEffect = () => {
  useTailwindClasses();
  usePruneInactiveStoryboards();
  return <></>;
};
